import { observer } from 'mobx-react';
import React, { useCallback, useEffect } from 'react';
import { useParams } from 'react-router';

import useStores from 'hooks/use-stores';
import Utils from 'utils/Utils';

import ItemWrapper from './item/v2/Item';

import EmptyLoadingBox from '../components/panel/EmptyLoadingBox';

const RETRY_TIME = 1000;

const Item: React.FC = () => {
    const { itemId } = useParams<{ itemId: string }>();
    const { bulletinStore } = useStores();

    const sendGA = useCallback((title) => {
        try {
            const { pathname, search, href } = window.location;
            window.ga('set', { page: pathname + search, location: href, title });
            window.ga('send', 'pageview');
        } catch (_error) {
            setTimeout(() => sendGA(title), RETRY_TIME);
        }
    }, []);

    useEffect(() => {
        bulletinStore
            .loadItem({ id: itemId })
            .then(() => {
                const title = bulletinStore.shortTitle || document.title;
                document.title = title;
                const descriptionElement = document.querySelector('meta[name=description]');
                const description =
                    bulletinStore.shortTitle.shortDescription || descriptionElement?.getAttribute('content');
                descriptionElement?.setAttribute('content', description);
            })
            .then(() => {
                sendGA(document.title);
            })
            .then(() => {
                Utils.scrollTo(0, 0);
            });
    }, [bulletinStore, itemId, sendGA]);

    const data = bulletinStore.data;
    const references = bulletinStore.references;

    return data.id === itemId ? (
        <ItemWrapper {...{ data, references }} />
    ) : (
        <div className="vulners-landing-item-tab flex1">
            <EmptyLoadingBox fullWidth />
        </div>
    );
};

export default observer(Item);
